export default "__VITE_ASSET__C_RAl9K3__"